import React from "react";
function SubContactInfo(props) {
  let colordata = props.colordata;
  let rs = props.rs;
  let ff = rs?.contactInfo?.content;
  if (ff?.length) {
    ff = JSON?.parse(ff);
  }
  if (ff?.length) {
    ff = JSON?.parse(ff);
  }

  // console.log(ff,"adfff")
  //return {rs?.contactInfo && ( )
  return (
    <>
      <article class="contact sec">
        <h3 class="sectitle"  style={{color: colordata?.dynamicTextHeadingColor || "" }}>Contact Info</h3>
   
        <ul class="conlink">
          <li>
            <a href={ff?.contactInfoPhone ? `tel:${ff?.contactInfoPhone}` : ""}>
              <i class="fa-solid fa-phone"  style={{ color: `${colordata?.dynamicTextHeadingColor}90` || ""}}></i>
              <span style={{ color: `${colordata?.dynamicTextHeadingColor}90` || ""}}>{ff?.contactInfoPhone}</span>
            </a>
            <a href={ff?.optionalContactInfoPhone ? `tel:${ff?.optionalContactInfoPhone}` : ""}>
              {/* <i class="fa-solid fa-phone"  style={{ color: `${colordata?.dynamicTextHeadingColor}90` || ""}}></i> */}
              <span style={{ color: `${colordata?.dynamicTextHeadingColor}90` || "",paddingLeft:"30px"}}>{ff?.optionalContactInfoPhone}</span>
            </a>
            
          </li>

          <li>
            <a
              href={
                ff?.contactInfoEmail ? `mailto:${ff?.contactInfoEmail}` : ""
              }
            >
              <i class="fa-solid fa-envelope" style={{ color: `${colordata?.dynamicTextHeadingColor}90` || ""}}></i>
              <span className="mailurllong" style={{ color: `${colordata?.dynamicTextHeadingColor}90` || ""}}>{ff?.contactInfoEmail}</span>
            </a>
          </li>
          <li>
                    <a href="">
                      <i class="fa-solid fa-globe" style={{ color: `${colordata?.dynamicTextHeadingColor}90` || ""}}></i>
                      <span className="mailurllong" style={{ color: `${colordata?.dynamicTextHeadingColor}90` || ""}}>{ff?.contactInfoWebUrl}</span>
                    </a>
                  </li>

          <li>
            <a  href={"" }>
            <i class="fa-solid fa-location-dot" style={{ color: `${colordata?.dynamicTextHeadingColor}90` || ""}}></i>
              <span className="breakText" style={{ color: `${colordata?.dynamicTextHeadingColor}90` || ""}}> 
              {ff?.contactInfoAddress?.split('\n').map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
             </span>
            </a>
          </li>   

           {ff?.contactInfoOptAddress && 
                    <li>
                      <p style={{color:colordata?.dynamicTextHeadingColor || "darkgrey", fontSize:"14px", margin:"0 0px 0 30px"}}>Alternative Address</p>  
                      <a>
                        <span style={{color:`${colordata?.dynamicTextHeadingColor}90` || '', marginLeft:"30px"}}>
                        {ff?.contactInfoOptAddress?.split('\n').map((line, index) => (
                        <React.Fragment key={index}>
                          {line}
                          <br />
                        </React.Fragment>
                      ))}
                        </span>
                      </a>
                    </li>
                    }       
         
        </ul>
      </article>
    </>
  );
}
export default SubContactInfo;
